import React, { useState } from 'react'
import styled from 'styled-components'
import { useRouteMatch, Link } from 'react-router-dom'
import { Button, ButtonMenu} from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'

const TimeDiv = styled.div<{ disabled?: boolean, width?: string, count: number}>`
    width: ${({ width }) => (width || 'auto')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    background-color: ${({ theme }) => theme.alert.background};
    /* background-color: rgb(239, 244, 245); */
    border-radius: 16px;
    display: inline-flex;
    
    border:${({ theme }) => theme.isDark?'1px solid rgb(85 66 66)':'1px solid rgb(233, 234, 235)'} ;
    /* border:1px solid rgb(117 117 117); */
    Button{
        box-shadow: none;
        font-size: 12px;
        width: ${({ count }) => (100/count)}%;
        text-align: center;
        &.activeLi{
            background-color: transparent;
            color: #f98c08;
            box-shadow: none;
            :hover{
                color: #fff;
            }
            :focus{
                box-shadow:none
            }
        }
    }
`
export interface DateSelectionProps {
    Date: {
        idx:number
        label:string,
        val:number
    }[]
    selectDay:(e)=> void
    isDisbale:number,
     // 0禁用组件,1开启组件
    selectDayIdx:number,
    width?: any
}

const DateSelection:React.FC<DateSelectionProps>= ({selectDayIdx,Date,selectDay,isDisbale,width}) => {
  const TranslateString = useI18n()
 

  const [state,setState]=useState(selectDayIdx);
  const changeLi=(e:any)=>{
    console.log(e)
    setState(e)
    selectDay(e);
  }
  return (
    <TimeDiv disabled={isDisbale===0} width={width} count={Date.length}>
        {
            Date.map((t)=>{
               return (<Button 
                disabled={isDisbale===0}
                size="sm" 
                className={state===t.idx&&isDisbale===1?'':'activeLi'} 
                onClick={()=>changeLi(t.idx)}>
                {t.label}
               </Button>)
            })
        }
   </TimeDiv>
  )
}

export default DateSelection
